import { connect } from 'react-redux'

import TabRatingReview from './units'

const mapStateToProps = (state) => {
  const review = state.ProjectManagement.review.rows
  let creatorReview = []
  const clientReview = review.filter(dataReview => (
    dataReview.category === 'creator'
  ))
  clientReview.forEach(client => {
    review.forEach(dataReview => {
      if (
        dataReview.category === 'client' &&
        client.profile.id === dataReview.reviewedBy.id &&
        client.reviewedBy.id === dataReview.profile.id
      ) {
        creatorReview.push(dataReview)
      }
    })
  })
  return {
    creatorReview,
    clientReview,
  }
}

export default connect(mapStateToProps)(TabRatingReview)
